/**
 * 搜索热点通用列表组件
 * Yin.qingdong
 * 2019-4-15
 */
"use strict";
angular.module("shCommonListModule", []).
directive("shCommonList", [function() {
    return {
        restrict: "E",
        replace: true,
        scope: {
            item: "=",
            callback: '&',
            initCallback: '&'
        },
        templateUrl: "./planningCenter/hotFocus/channelHotSpots/searchHotSpots/directive/shCommonList/shCommonList_tpl.html",
        link: function(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {

                }
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                scope.status.curTab = scope.item.tabnames[0];
            }

            /**
             * [jumpPrePage description]跳转页面
             * @param  {[type]} itemobj [description]
             * @return {[type]}         [description]
             */
            scope.jumpPrePage = function(itemobj) {
                if (itemobj.param.page_no == 0) {return;}
                itemobj.param.page_no--;
                scope.callback();
            }

            scope.jumpNextPage = function(itemobj) {
                if (itemobj.param.page_no >= (itemobj.param.allPages-1)) {return;}
                itemobj.param.page_no++;
                scope.callback();
            }

            /**
             * [changeTabs description]切换tabs
             * @return {[type]} [description]
             */
            scope.changeTabs = function(item, tab) {
                item.activeName = tab.displayTabName;
                scope.status.curTab = tab;
            }

            /**
             * [jumpOrgText description]跳转到原文
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            scope.jumpOrgText = function(item) {
                window.open(item.URLNAME);
            }

            scope.openPannelDetail = function(item) {
                item.isOpen = true;
                scope.initCallback();
            }
        }
    }
}]);